export const MEDIA_QUERIES = {
  prefersReducedMotion: '(prefers-reduced-motion: reduce)',
  prefersLightColorScheme: '(prefers-color-scheme: light)',
  prefersDarkColorScheme: '(prefers-color-scheme: dark)',
};
